import { ShopifyCartItem } from '@/lib/shopify';
import {
  convertCartLineItemPropertiesToAttributes,
  getCartLineItemProperty,
} from '@/utils/shopify';
import { CartItemProperty } from '@/core/constants';
import { PlayKitSubscriptionSettings } from './types';

export function buildPlayKitSubscriptionKey(
  playKitSubscriptionProduct: ShopifyCartItem,
  bookBundleAddonProduct: ShopifyCartItem | null,
): PlayKitSubscriptionSettings | null {
  const attributes = convertCartLineItemPropertiesToAttributes(
    playKitSubscriptionProduct.properties,
  );

  const playKitSubscriptionSettings = getCartLineItemProperty(
    CartItemProperty.PlayKitSubscriptionSettings,
    attributes,
    { parseJson: true },
  );

  if (!playKitSubscriptionSettings) {
    return null;
  }

  const typedPlayKitSubscriptionSettings =
    playKitSubscriptionSettings as unknown as PlayKitSubscriptionSettings;

  // set add_ons to an empty array if there is no associated book bundle addon product.
  // this supports the case of a user adding books in the subflow, then removing the book product in the cart.
  if (!bookBundleAddonProduct) {
    typedPlayKitSubscriptionSettings.add_ons = [];
  }

  return typedPlayKitSubscriptionSettings;
}
